import { useMemo } from "react"

import type { ToggleableColumn } from "./TestCaseColumnVisibility"

export interface ColumnWidths {
  number: string
  id: string
  type: string
  description: string
  testCaseDescription: string
  behaviors: string
  metadata: string
  kbEntries: string
  simulationMetadata: string
  actions: string
  addColumn: string
}

const MIN_COLUMN_WIDTH = "300px"

const FIXED: Record<string, number> = {
  number: 28,
  id: 140,
  type: 88,
  simulationMetadata: 200,
  actions: 120,
  addColumn: 120,
}

type FixedColumnKey = "simulationMetadata" | "actions"

export const useColumnWidths = (
  visibleColumns: Set<ToggleableColumn>,
  hasAddColumn = true,
  extraFixedColumns: Set<FixedColumnKey> = new Set(),
): ColumnWidths => {
  return useMemo(() => {
    const showId = visibleColumns.has("id")
    const showType = visibleColumns.has("type")
    const showDescription = visibleColumns.has("description")
    const showBehaviors = visibleColumns.has("behaviors")
    const showMetadata = visibleColumns.has("metadata")
    const showKbEntries = visibleColumns.has("kbEntries")

    const numberWidth = FIXED.number

    const widths: ColumnWidths = {
      number: `${numberWidth}px`,
      id: showId ? `${FIXED.id}px` : "0px",
      type: showType ? `${FIXED.type}px` : "0px",
      description: MIN_COLUMN_WIDTH,
      testCaseDescription: showDescription ? MIN_COLUMN_WIDTH : "0px",
      behaviors: showBehaviors ? MIN_COLUMN_WIDTH : "0px",
      metadata: showMetadata ? MIN_COLUMN_WIDTH : "0px",
      kbEntries: showKbEntries ? MIN_COLUMN_WIDTH : "0px",
      simulationMetadata: extraFixedColumns.has("simulationMetadata")
        ? `${FIXED.simulationMetadata}px`
        : "0px",
      actions: extraFixedColumns.has("actions") ? `${FIXED.actions}px` : "0px",
      addColumn: hasAddColumn ? `${FIXED.addColumn}px` : "0px",
    }

    return widths
  }, [visibleColumns, hasAddColumn, extraFixedColumns])
}
